import { useQuery } from '@apollo/client';

import {
  GetTicketingConnectionsQuery,
  GetTicketingConnectionsQueryVariables,
  GET_TICKETING_CONNECTIONS,
} from '../graphql';

/**
 * The connections list's own read. Kept off `GET_COMPANY` on purpose: three of these fields are
 * field resolvers — two database queries per connection plus a live Merge probe — and `GET_COMPANY`
 * is the app-wide company query that some connect flows poll every second.
 */
export const useTicketingConnections = (
  companyId: string,
): {
  company: GetTicketingConnectionsQuery['getCompany'] | null;
  loading: boolean;
} => {
  const { data, loading } = useQuery<GetTicketingConnectionsQuery, GetTicketingConnectionsQueryVariables>(
    GET_TICKETING_CONNECTIONS,
    { variables: { companyId } },
  );

  return { company: data?.getCompany ?? null, loading };
};
